<template>
  <emd-text-section :title="$t('payment-method.boleto')">
    <emd-text-content
      v-if="Object.values(data.dueIn).length"
      :title="$t('dueIn.title')"
    >
      <div class="eu-inline">
        <span v-if="data.dueIn.years">
          {{ $tc('dueIn.years', data.dueIn.years) }}
        </span>
        <span v-if="data.dueIn.months">
          {{ $tc('dueIn.months', data.dueIn.months) }}
        </span>
        <span v-if="data.dueIn.months && data.dueIn.days">
          {{ $t('dueIn.append') }}
        </span>
        <span v-if="data.dueIn.days">
          {{ $tc('dueIn.days', data.dueIn.days) }}
        </span>
      </div>
    </emd-text-content>

    <due-at
      v-else
      :dueAt="data.dueAt"
    />

    <discount :data="data" />
  </emd-text-section>
</template>

<script>
import { EmdTextSection, EmdTextContent } from 'emerald-vue/src/components'

export default {
  name: 'BoletoPaymentLinks',

  components: {
    EmdTextSection,
    EmdTextContent,
    DueAt: () => import('./DueAt.vue'),
    Discount: () => import('./Discount.vue')
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "dueIn": {
        "title": "Tempo até vencimento",
        "years": "- | 1 ano | {count} anos",
        "months": "- |1 mês | {count} meses",
        "days": "- |1 dia | {count} dias",
        "append": "e"
      }
    },
    "en-US": {
      "dueIn": {
        "title": "Time until pay",
        "years": "- | 1 year | {count} years",
        "months": "- |1 month | {count} months",
        "days": "- |1 day | {count} days",
        "append": "and"
      }
    }
  }
</i18n>
